import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close';

import { Dialog } from '../Dialog'
import Button from '../Button'
import Typography from '../Typography'
import Avatar from '../Avatar'

const DialogWrapper = withStyles(theme => ({
  paper: {
    alignItems: 'center',
    background: theme.palette.background.default,
    display: 'flex',
    justifyContent: 'center',
    padding: '0 12px',
    position: 'relative',
    textAlign: 'center',
    overflow: 'hidden',
  },
  root: {
    height: 306,
    marginRight: theme.spacing(4),
    maxWidth: 300,
    minWidth: 219,
    position: 'relative !important',
    top: '12px !important',
    zIndex: '99999 !important',
  },
}))(Dialog)

const ButtonWrapper = withStyles(theme => ({
  label: {
    fontSize: 12,
  },
  root: {
    marginTop: 20,
    padding: '4px 10px',
    height: theme.spacing(4),
  },
}))(Button)

const LogoutDialog = ({ handleClose, open, handleLogout, user, activeUser }) => (
  <DialogWrapper
    aria-labelledby="customized-dialog-title"
    className="Logout"
    fullScreen
    onClose={handleClose}
    open={open}
  >
    <IconButton aria-label="close" className="CloseButton" onClick={handleClose}>
      <CloseIcon />
    </IconButton>
    <Avatar aria-label="Profile" className="Avatar">
      {`${user.given_name.charAt(0).toUpperCase()}${user.surname.charAt(0).toUpperCase()}`}
    </Avatar>
    <Typography align="center" className="Name" component="h2" variant="h4">
      {`${user.given_name} ${user.surname}`}
    </Typography>
    <Typography className="Email" variant="subtitle1">
      {activeUser.get('email')}
    </Typography>
    <ButtonWrapper autoFocus color="primary" onClick={handleLogout} variant="outlined">
      Sign Out
    </ButtonWrapper>
  </DialogWrapper>
)

export default LogoutDialog
